export default "__VITE_ASSET__BD5FP6vz__"